import axios from 'axios';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { useStaffStore } from 'pages/admin-dashboard/staff/store';
import { queryCache, useMutation } from 'react-query';
import { PartnerUserRole } from 'utils/formatPartnerUserRole';
import useStore from 'zstore';

type CreatePartnerUserRoleParams = {
  partnerId: string;
  payload: CreatePartnerUserRolePayload;
};

type CreatePartnerUserRolePayload = {
  email: string;
  role: PartnerUserRole;
};

const createPartnerUserRole = ({ partnerId, payload }: CreatePartnerUserRoleParams) => {
  return axios.post(`/api/v3/partners/${partnerId}/partner_user_roles`, payload);
};

export const useCreatePartnerUserRole = () => {
  const user = useCurrentUser();
  const { makeToast } = useStore();
  const { pageNumber, pageSize, sortColumn, sortDirection, name } = useStaffStore();

  return useMutation(createPartnerUserRole, {
    onSuccess: () => {
      makeToast({
        text: 'Successfully invited new staff member',
        isError: false,
      });
    },
    onError: (error: any) => {
      console.error(error);
      makeToast({
        text: 'Uh-oh! Something went wrong. Please try again.',
        isError: true,
      });
    },
    onSettled: () => {
      queryCache.invalidateQueries([
        'partnerUserRoles',
        user?.primaryPartner.id,
        pageNumber,
        pageSize,
        sortColumn,
        sortDirection,
        name,
      ]);
    },
  });
};
